import React, {useEffect, useState} from 'react'
import {Navigate, useNavigate} from 'react-router-dom'
import {Container} from 'semantic-ui-react'
import {useAuth} from '../context/AuthContext'
import {tripApi} from '../misc/TripApi'
import {handleLogError} from '../misc/Helpers'
import TripForm from "./TripForm";
import moment from "moment";

function TripFormPage() {
  const Auth = useAuth()
  const user = Auth.getUser()
  const isUser = user.role === 'USER'
  const navigate = useNavigate()

  const [fromCity, setFromCity] = useState('')
  const [toCity, setToCity] = useState('')
  const [tripDate, setTripDate] = useState('')
  const [tripHour, setTripHour] = useState('00')
  const [tripMin, setTripMin] = useState('00')
  const [cost, setCost] = useState('')
  const [maxPassengers, setMaxPassengers] = useState('')
  const [notes, setNotes] = useState('')
  const [showCalendar, setShowCalendar] = useState(false);

  useEffect(() => {
  }, [])

  const handleCreateTrip = async () => {
    try {
      const trip = {
        fromCity: fromCity, toCity: toCity, tripDate: tripDate, tripHour: tripHour, tripMin: tripMin,
        cost: cost, maxPassengers: maxPassengers, notes: notes
      }
      await tripApi.createTrip(user, trip)
      navigate('/')
    } catch (error) {
      handleLogError(error)
    }
  }

  const handleDateChange = value => {
    setTripDate(moment(value).format( 'DD/MM/YYYY'))
    setShowCalendar(false)
  };

  const handleInputChange = (e, {name, value}) => {
    if (name === 'fromCity') {
      setFromCity(value)
    } else if (name === 'toCity') {
      setToCity(value)
    } else if (name === 'tripHour') {
      setTripHour(value)
    } else if (name === 'tripMin') {
      setTripMin(value)
    } else if (name === 'cost') {
      setCost(value)
    } else if (name === 'maxPassengers') {
      setMaxPassengers(value)
    } else if (name === 'notes') {
      setNotes(value)
    }
  }

  if (!isUser) {
    return <Navigate to='/'/>
  }

  return (
    <Container>
      <TripForm
        fromCity={fromCity}
        toCity={toCity}
        tripDate={tripDate}
        tripHour={tripHour}
        tripMin={tripMin}
        cost={cost}
        maxPassengers={maxPassengers}
        notes={notes}
        handleInputChange={handleInputChange}
        handleCreateTrip={handleCreateTrip}
        showCalendar={showCalendar}
        setShowCalendar={setShowCalendar}
        handleDateChange={handleDateChange}
      />
    </Container>
  )
}

export default TripFormPage
